import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { MoveFocusInside } from 'react-focus-lock';

import NavChevron from '../../../images/nav-chevron.svg';
import Ctas from '../Ctas';

export const Menu = styled.div``;

export const Links = styled.ul`
  margin: 40px 0;

  li {
    display: flex;
    font-size: 1rem;
    padding: 1.125rem 1.25rem;
    border-bottom: 1px solid ${themeGet('colors.cta-border-grey')};
  }

  li:not(:first-child) {
    margin-top: 0;
  }

  a {
    font-size: 1rem;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: ${themeGet('colors.main-text')};

    &:hover,
    &:focus {
      opacity: 0.8;
      color: ${themeGet('colors.main-text')};
      text-decoration: underline;
    }
  }

  &.submenu {
    min-height: ${props =>
      props.$minItems < 5
        ? `100%`
        : `calc(100vh + ${(props.$minItems - 3) * 1}rem)`};
    li {
      display: flex;
    }
  }
`;

export const Logo = styled.img`
  width: 100%;
  max-width: 120px;
  height: 100%;
  max-height: 48px;
`;

export const Wrapper = styled.div`
  position: absolute;
  z-index: 1101;
  visibility: ${props => (props.$isOpen ? 'visible' : 'hidden')};
  transition: all 300ms ease-in-out;
  transform: translate3d(
    100%,
    calc(-1.125rem - ${props => `${props.$positionIdx * 61}px`}),
    0
  );
  &.slide-in {
    transform: translate3d(
      calc(0% - 1.25rem),
      calc(-1.125rem - ${props => `${props.$positionIdx * 61}px`}),
      0
    );
  }
  width: 100%;
  background-color: ${themeGet('colors.white')};
  height: 100%;
  overflow: auto;
`;

export const NavButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: auto;

  &:after {
    content: '';
    height: 1.25rem;
    width: 1.25rem;
    background-image: url(${NavChevron});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    transform: rotate(270deg);
  }

  ${Links}.submenu & {
    justify-content: flex-start;
    &:before {
      content: '';
      height: 1.25rem;
      width: 1.25rem;
      background-image: url(${NavChevron});
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      transform: rotate(90deg);
      margin-right: 0.75rem;
    }
    &:after {
      display: none;
    }
  }
`;

export const StyledMoveFocusInside = styled(MoveFocusInside)`
  display: flex;
  positive: relative;
`;

export const MenuFooter = styled.div`
  display: flex !important;
  position: absolute;
  bottom: 0;
  justify-content: center;
  box-shadow: -0.25rem 0 1.25rem 0 rgba(0, 0, 0, 0.1);
  padding: 1rem 2.75rem;
`;

export const StyledMenuCtas = styled(Ctas)`
  margin-top: 0;
  margin-bottom: 0;
  flex-direction: row;
  gap: 0.5rem;
`;
